<template>
  <div
    id="app-loaded"
    :style="bgStyle"
  >
    <div
      id="app_bg_wrapper"
      class="app-bg-wrapper"
    />
    <MobileNav v-if="layoutType === 'mobile'" />
    <DesktopNav v-else />
    <Notifications v-if="currentUser" />
    <div
      id="content"
      class="app-layout container"
      :class="classes"
    >
      <div class="underlay" />
      <div
        id="sidebar"
        class="column -scrollable"
        :class="{ '-show-scrollbar': showScrollbars }"
      >
        <user-panel />
        <template v-if="layoutType !== 'mobile'">
          <nav-panel />
          <instance-specific-panel v-if="showInstanceSpecificPanel" />
          <features-panel v-if="!currentUser && showFeaturesPanel" />
          <who-to-follow-panel v-if="currentUser && suggestionsEnabled" />
          <div id="notifs-sidebar" />
        </template>
      </div>
      <div
        id="main-scroller"
        class="column main"
        :class="{ '-full-height': false }"
      >
        <div
          v-if="!currentUser"
          class="login-hint panel panel-default"
        >
          <router-link
            :to="{ name: 'login' }"
            class="panel-body"
          >
            {{ $t("login.hint") }}
          </router-link>
        </div>
        <router-view />
      </div>
      <div
        id="notifs-column"
        class="column -scrollable"
        :class="{ '-show-scrollbar': showScrollbars }"
      >
        <div class="bitlyfool-network-panel">
          <div class="bitlyfool-network-header">
            <div class="bitlyfool-network-title">BITLYFOOL</div>
            <div class="bitlyfool-network-tagline">
              ONE NETWORK. MANY FRONTIERS.
            </div>
          </div>

          <a
            class="bitlyfool-network-card bitlyfool-com"
            href="https://bitlyfool.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="network-icon">🌐</span>
            <span class="network-info">
              <strong>BitlyFool.com</strong>
              <small>News · Investigations · Commentary</small>
            </span>
            <span class="network-arrow">›</span>
          </a>

          <a
            class="bitlyfool-network-card bitlyfool-us"
            href="https://bitlyfool.us"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="network-icon activitypub-icon">
      <img
        src="./assets/activitypub-logo-symbol.svg"
        alt="ActivityPub"
        aria-hidden="true"
      >
    </span>
            <span class="network-info">
              <strong>BitlyFool.us</strong>
              <small>ActivityPub · Social · Federated</small>
            </span>
            <span class="network-arrow">›</span>
          </a>

          <a
            class="bitlyfool-network-card bitlyfool-net"
            href="https://bitlyfool.net"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="network-icon">⚡</span>
            <span class="network-info">
              <strong>BitlyFool.net</strong>
              <small>Nostr · Decentralized · Relay</small>
            </span>
            <span class="network-arrow">›</span>
          </a>

          <div class="bitlyfool-bridge">
            <div class="bridge-title">
              <span class="bridge-icon">⇄</span>
              ActivityPub ↔ Nostr
            </div>
            <div class="bridge-subtitle">
              BitlyFool Bridge
            </div>
            <div class="bridge-handle">
              @bitlyfool@bridge.bitlyfool.us
            </div>
          </div>
        </div>
      </div>
    </div>
    <media-modal />
    <MobilePostStatusButton />
    <UserReportingModal />
    <PostStatusModal />
    <EditStatusModal v-if="editingAvailable" />
    <StatusHistoryModal v-if="editingAvailable" />
    <SettingsModal />
    <ModModal />
    <SearchFormModal />
    <GlobalNoticeList />
  </div>
</template>

<script src="./App.js"></script>
<style lang="scss" src="./App.scss"></style>
